import { createContext, useState, useEffect } from "react";
import welcomejourneyService from "../services/welcomejourney.service";
import { CustomerJourneyDetail } from "../types/welcomejourney/CustomerJourneyDetail"; 
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { AccessPermissionEnum } from "../enums";

type WelcomeJourneyContextType = {
    showToolTip: boolean;
    journey?: CustomerJourneyDetail;
    journeyActive: boolean;
    journeyRunning: boolean;
    updateJourneys : (customerId: number, journeyStageId: number, completedState: boolean) => Promise<void>;
    displayToolTip: (show: boolean) => void;
    getJourney: () => Promise<CustomerJourneyDetail | undefined>;
    dontShowJourneys: () => Promise<void>;
    updateJourneyRunning: (isJourneyRunning: boolean) => void;
};



const WelcomeJourneyContext = createContext<WelcomeJourneyContextType | null>(null);

export const WelcomeJourneyProvider: React.FC<{children: React.ReactNode}> = ({
    children,
}) => {

    const [journey, setJourney] = useState<CustomerJourneyDetail>();
    const [showToolTip, setShowToolTip] = useState<boolean>(true);
    const [journeyActive, setJourneyActive] = useState<boolean>(false);
    const [journeyRunning, setJourneyRunning] = useState<boolean>(false);
    const [isFirstLogin, setIsFirstLogin] = useState<boolean>(false);
    const auth = useAuth();
    const navigate = useNavigate();

    const updateJourneys = async (customerId: number, journeyStageId: number, completedState: boolean) => {
        var journies = await welcomejourneyService.updateCustomerjourney(customerId, journeyStageId, completedState);
        setJourney(journies);
        setJourneyRunning(false);

        if(journeyStageId === 5 && completedState === true)
        {
            navigate("/maxexperience", { replace: true });
        }
     };

    const displayToolTip = (show: boolean) => {
        setShowToolTip(show);
    };

    useEffect(()=>{
        console.log(journeyRunning);
    },[journeyRunning]);

    const updateJourneyRunning = (isJourneyRunning: boolean) => {
        setJourneyRunning(isJourneyRunning);
    }

    const dontShowJourneys = async () =>
    {
        await welcomejourneyService.updateUserJourneyConfigSkipped(auth?.tokenPayload?.CustomerId??0)
        setJourney(undefined);
    }    

    const getJourney = async () =>
    {
        if(auth?.tokenPayload)
        {
            var tempjourney = await welcomejourneyService.getCustomerJourney(auth.tokenPayload?.CustomerId);

            if(tempjourney && tempjourney.journeyStages)
                {        
                    setJourneyActive(true);
                }
                else
                {
                    setJourneyActive(false);
                }
            
            setJourney(tempjourney);

            return tempjourney;
        }
    };

    const getJourneys = async () => {
       return await getJourney();
    };

    useEffect(()=>
    {
        if(auth?.checkUserAccess(AccessPermissionEnum.ManageSecurityControl))
        {
            getJourneys();
        }

        setJourneyRunning(false);              
    },[auth?.tokenPayload, auth?.userPermissions]);

    return (
        <WelcomeJourneyContext.Provider
            value={{
                journey,
                showToolTip,
                journeyActive,
                journeyRunning,
                updateJourneys,
                displayToolTip,
                getJourney,
                dontShowJourneys,
                updateJourneyRunning
            }}
        >
            {children}
        </WelcomeJourneyContext.Provider>
    );
};

export default WelcomeJourneyContext;